import React from 'react';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { opsSettingsLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { globalIncomingCallRoute } from '@jira/router-routes__eoc-incoming-call-routes/src/globalIncomingCallRoute.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { LazySidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { listResources } from '@atlassian/eoc-incoming-call/resources';
import type { Route, RouteResources } from '@atlassian/react-resource-router';
import { LazyIncomingCall } from './ui/async.tsx';

const IncomingCall = () => (
	<LazyPage
		Page={LazyIncomingCall}
		pageId="async-jira-eoc-incoming-call"
		shouldShowSpinner={false}
	/>
);

const getNavigationSpecifications = () => {
	return {
		sidebarId: SidebarIdOperationsGeneralConfiguration,
	};
};

// Global routes
export const globalIncomingCallRouteEntry: Route = createEntry(globalIncomingCallRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: IncomingCall,
	layout: opsSettingsLayout,

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	resources: [
		...getNavigationResources(),
		...getNavigationSidebarProductsSettingResource(),
		...listResources(),
	] as RouteResources,

	navigation: {
		menuId: MenuIdSettings,
		...getNavigationSpecifications(),
	},

	forPaint: [LazySidebarContent, LazyAtlassianNavigation, LazyIncomingCall],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
